import { PROGRAM_PROFILES } from "./programProfiles";

export const PROGRAMS = Object.entries(PROGRAM_PROFILES).map(
  ([name, profile]) => ({
    name,
    profile: profile.behaviourProfile
  })
);